export default  {
    add_booth: 'Manually add the new booth',
    search_text: 'Please input your text',
    special_booth: 'Special',
    standard_booth: 'Standard',
    add_shopcart: 'ADD TO CART',
    add_food_shopcart: 'ADD TO CART',
    lease_list: 'Lease list',
    go_settlement: 'To settle accounts',
    total_amount: 'Total',
    foregift_title: 'Foregift：',
    price_title: 'rent:',
    specifications_title: 'Spec',
    buyNum_title: 'Qty',
    description_title: 'Description',
    all: 'All',
    no_message: 'There is no product available for rent under the current category, please contact home configuration',
    shopName: 'Renting goods',
    unit: 'unit',
    drawText:'Details of illustrations and texts',
    baseinfo: 'Base Info',
    shopdetailname: 'Goods Name',
    color: 'Color',
    texture: 'Texture',
    '返回商品列表':'Returns the list of items',
    '提示':'tips',
    '展位':'Booth:',
    '参展商':'Exhibitor:',
    '是':'YES',
    '不是':'NO',
    '库存不足':'Shortage of stock, please reduce the quantity of purchases',
    '选中的展位':'Selected booth:',
    '是您的展位吗':'Is this your booth?',
    '绑定展位成功':'Binding booth success',
    '至少选择一个展位进行添加':'Choose at least one booth to add',
    '您没有添加展位':'You did not add booths, Please add booths and choose goods.',
    '类型':'type',
    '首页':'home page',
    '租赁商品列表':'List of Leased Goods',
    '添加展位':'Adding',
    '全部':'ALL',
    '搜索':'search',
    '件商品':'piece',
    '收起':'Retract',
    '展开':'Open',
    '删除':'delete',
    '总结':'summary',
    '去结算':'Settlement',
    '单价':'',
    '含押金':'Foregift',
    '租赁清单空空的~':'empty',
    '更多':'more',
    '请先选择商品需要派送的展位，再进行下单':'Please select the booth to be dispatched before placing an order',
    '租赁服务':'Rental services',
    '暂无可添加展位':'No booth can be added temporarily'
  }


// WEBPACK FOOTER //
// ./src/i18n/en-us/shopList.js